import React, { Component } from 'react';
import logo from './assets/logo.jpeg';
import portfolio1 from './assets/portfolio1.png';
import portfolio2 from './assets/portfolio2.png';
import portfolio3 from './assets/portfolio3.png';
import portfolio4 from './assets/portfolio4.png';
import portfolio5 from './assets/portfolio5.png';
import portfolio6 from './assets/portfolio6.png';
import portfolio7 from './assets/portfolio7.png';
import portfolio8 from './assets/portfolio8.png';
import { Typography, CssBaseline, AppBar, Toolbar, Button, Chip, Fab, Grid, Tabs, Tab, Card, CardMedia, CardContent, Modal, Paper, Divider, LinearProgress, CircularProgress, Collapse, List, ListItem, ListItemText } from '@material-ui/core';
import Slider from "react-slick";
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
      portfolioValue: 0,
      modalVisible: false,
      open: false,
      portfolios: [{
        name: `Family GPS Tracker`,
        image: portfolio1,
        category: `Mobile App Development`,
        code: 1,
        intro: `Family locator is an essential tool right in your pocket. This is efficient cell phone locator to keep in touch with any of your family members round the clock. This GPS tracker app is the best bet in case you want to be aware of the location of every person that is dear to you.`,
        skills: `React Native, Firebase`
      },
      {
        name: `Service Provider App`,
        image: portfolio2,
        category: `Mobile App Development`,
        code: 1,
        intro: `It’s been a problem to find a service provider, for e.g someone's home fan has stopped working in a really hot weather, now what will he do? He will roam in his area to find the electrician or will call or message. So in order to overcome this problem, this application would be proven as a great interactor between user and service provider. On the other hand, one who has some skills but he is not getting jobs, he could also add his services in the application for the users even in his area. `,
        skills: `React Native, React.js, Node.js, MongoDB`
      },
      {
        name: `Chat App`,
        image: portfolio3,
        category: `Web Development`,
        code: 0,
        intro: ` Its a simple Chat App made with PWA Technology.`,
        skills: `HTML, CSS, Javascript`
      },
      {
        name: `Olx App`,
        image: portfolio4,
        category: `Web Development`,
        code: 0,
        intro: `This app is clone of OLX made with PWA Technology.`,
        skills: `HTML, CSS, Javascript, Firebase`
      },
      {
        name: `MaSender App`,
        image: portfolio5,
        category: `Mobile App Development`,
        code: 1,
        intro: `This is a kind of one to all communication app. User makes a title and other follows that title as user send a message on its title all its followers receive that but cannot reply. This app is very useful in companies for boss to employees communication.`,
        skills: `React Native, Firebase`
      },
      {
        name: `Meeting App`,
        image: portfolio6,
        category: `Web Development`,
        code: 0,
        intro: ` Meeting App like Tinder. Through this app we can set meeting with users.`,
        skills: `React.js, Firebase`
      },
      {
        name: `React Quiz App`,
        image: portfolio7,
        category: `Web Development`,
        code: 0,
        intro: `: A simple Quiz App build for web platform. Test your knowledge now.`,
        skills: `React.js, Firebase`
      },
      {
        name: `React Native Quiz App`,
        image: portfolio8,
        category: `Mobile App Development`,
        code: 1,
        intro: `This is a simple quiz app. We can test our knowledge by giving quizes. There are different types of quizes in this app.`,
        skills: `React Native, Firebase`
      }
    ]
    };

    this.marquee = React.createRef();
    this.modalImage = React.createRef();
    this.modalIntro = React.createRef();
    this.modalSkill = React.createRef();

    this.modalOpen = this.modalOpen.bind(this);
  }
  
  modalOpen(index) {
    let { portfolios } = this.state;
    this.setState({ modalVisible: true });
    setTimeout(_ => {
      this.modalImage.current.innerHTML = `<img width='80%' height='100%' src=${portfolios[index].image} alt="logo" />`;
      this.modalIntro.current.innerText = portfolios[index].intro;
      this.modalSkill.current.innerText = portfolios[index].skills;
    }, 1500)
  }

  render() {
    let { active, modalVisible, portfolios, portfolioValue, open } = this.state;
    return (
      <React.Fragment>
        <CssBaseline />
        <header>      
          <AppBar style={{background: '#F7F7F7'}}>
            <Toolbar>
              <Grid container direction='row' alignItems='center' justify={window.screen.width > 800 ? 'space-evenly' : 'space-between'}>
                <img src={logo} width={window.screen.width > 800 ? '300' : '200'} height='125' alt="logo" />
                 {window.screen.width > 800 ? <Tabs
                  value={active}
                  onChange={(event, newValue) => { this.setState({ active: newValue }) }}
                  indicatorColor="primary"
                  textColor="primary"
                  centered
                  >
                  <Tab onClick={_ => window.scrollTo(0,0)} label="Home" />
                  <Tab href='#services' label="Services" />
                  <Tab href='#portfolios' label="Portfolios" />
                  <Tab href='#clients' label="Our Clients" />
                  <Tab href='#contact' label="Contact Us" />
                </Tabs> : 
                <button onClick={_ => this.setState({ open: !open })} className="fb-ic">
                {open ? <i style={{color:'#3f51b5'}} className="fas fa-times fa-3x p-3"></i> : <i style={{color:'#3f51b5'}} className="fas fa-bars fa-3x p-3"></i>}
                  </button>}
              </Grid>
            </Toolbar> 
            <Collapse in={open} timeout="auto" unmountOnExit>
              <button className='ham-link btn-block' onClick={_ => window.scrollTo(0,0)}><List component="div" disablePadding>
                <ListItem button divider> 
                  <ListItemText className='ham-list-text' primary="Home" />
                </ListItem>
              </List></button>
              <a className='ham-link' href='#services'><List component="div" disablePadding>
                <ListItem button divider> 
                  <ListItemText className='ham-list-text' primary="Services" />
                </ListItem>
              </List></a>
              <a className='ham-link' href='#portfolios'><List component="div" disablePadding>
                <ListItem button divider> 
                  <ListItemText className='ham-list-text' primary="Portfolios" />
                </ListItem>
              </List></a>
              <a className='ham-link' href='#clients'><List component="div" disablePadding>
                <ListItem button divider> 
                  <ListItemText className='ham-list-text' primary="Our Clients" />
                </ListItem>
              </List></a>
              <a className='ham-link' href='#contact'><List component="div" disablePadding>
                <ListItem button > 
                  <ListItemText className='ham-list-text' primary="Contact Us" />
                </ListItem>
              </List></a>
            </Collapse>
          </AppBar>        
        </header>
        <main>                    
          <Grid id='video' container alignItems='center' justify='center'>               
            <iframe src="https://youtube.com/embed/Pq5vSHuvACY?autoplay=1&mute=1&loop=1&playlist=Pq5vSHuvACY" frameBorder="3" allowFullScreen title='console'></iframe>      
          </Grid>        
          <div id='services'></div>
              
          <Typography variant="h3" align="center" className='mainHeadings'>Services</Typography>
          <Grid className={window.screen.width > 600 ? 'parallax' : 'mobile-parallax'} container direction='row' alignItems='center' justify='space-evenly'>
            <Card className='servicesCard'>            
              <CardMedia
                className='servicesMedia'
                image={require('./assets/service1.jpeg')}
                title="Graphic Designing"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">Graphic Designing</Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                 We Design all types of logo, banner, advertisment, posts for your work providing fully featured work with differs us from others.
                </Typography>
              </CardContent>
              <div className="overlay2">
                <div className="text"></div>
              </div>
            </Card>
            <Card className='servicesCard'>             
              <CardMedia
                className='servicesMedia'
                image={require('./assets/service2.jpeg')}
                title="Mobile App Development"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">Mobile App Development</Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                 Full Stack Native Mobile App Development with maintainence support using latest technologies.
                </Typography>
              </CardContent>
              <div className="overlay2">
                <div className="text"></div>
              </div>
            </Card>
            <Card className='servicesCard'>            
              <CardMedia
                className='servicesMedia'
                image={require('./assets/service3.jpeg')}
                title="Web Development"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">Web Development</Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Fully Responsive Website of any type including e-commerce, single page etc. 
                </Typography>
              </CardContent>   
              <div className="overlay2">
                <div className="text"></div>
              </div> 
            </Card>
            <Card className='servicesCard'>            
              <CardMedia
                className='servicesMedia'
                image={require('./assets/service4.jpeg')}
                title="Printing"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">Printing</Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Printing of all kinds of stuff including post cards, gift cards photo etc providing great quality work and experience.
                </Typography>
              </CardContent>   
              <div className="overlay2">
                <div className="text"></div>
              </div>           
            </Card>
          </Grid>
          <div id='portfolios'></div>
          <Typography variant="h3" align="center" className='mainHeadings'>Portfolios
            <Tabs textColor='primary' TabIndicatorProps={{style: {background: 'none'}}} centered value={portfolioValue} onChange={(event, newValue) => { this.setState({ portfolioValue: newValue }) }}>
              <Tab className='portfolioTabs' label="Web Development" />
              <Tab className='portfolioTabs' label="Mobile App Development" />
              <Tab className='portfolioTabs' label="Graphic Designing" />
            </Tabs>
          </Typography>
                     
          <Grid className={window.screen.width > 600 ? 'parallax' : 'mobile-parallax'} container direction='row' alignItems='center' justify='space-evenly'>
            {
              portfolios.map((data, index) => {
                if(data.code === portfolioValue) {
                  return <Card key={index} onClick={_ => this.modalOpen(index)} className='cardContainer' raised>
                    <CardMedia
                    className='servicesMedia'
                      image={data.image}
                      title={data.name}
                    />
                    <CardContent>
                      <Grid container justify='flex-end'>
                        <Chip
                          size="small"
                          label={data.category}
                          color="primary"
                        />    
                      </Grid>
                    </CardContent>
                    <div className="overlay">
                      <div className="text"> {data.name} <hr style={{height: 2, background: 'white'}} /> View</div>
                    </div>
                  </Card>
                }
                return false        
              })
            }
           
          </Grid>
          <Modal open={modalVisible} style={{overflow: 'scroll'}}>      
            <Grid container alignItems='center' justify='center'>
              <Paper className='modalPaper'>
                <Grid container justify='flex-end'>
                  <Fab onClick={_ => this.setState({ modalVisible: false })} size="medium" style={{fontSize: '22px', color: '#3f51b5'}} aria-label="Add">X</Fab>
                </Grid>
                <Grid ref={this.modalImage} container alignItems='center' justify='center'>
                  <CircularProgress />
                </Grid>
                <br />
                <Divider variant="middle" style={{height: 3}} />
                <br />
                <Grid container direction='column'>
                  <Typography variant="h6" component="h3">Introduction:</Typography>
                  <Typography component="p">
                    <span ref={this.modalIntro}><LinearProgress style={{marginTop: 15}} /></span>
                  </Typography>
                  <br />
                  <Typography variant="h6" component="h3">Skills:</Typography>
                  <Typography component="p">
                    <span ref={this.modalSkill}><LinearProgress style={{marginTop: 15}} /></span>
                  </Typography>
                </Grid>
              </Paper>
            </Grid>          
          </Modal>
          <div id='clients'></div>
          <Typography variant="h3" align="center" className='mainHeadings'>Our Clients</Typography>
          <Grid className={window.screen.width > 600 ? 'parallax' : 'mobile-parallax'}>            
            <div className='container' style={{width: '40vw'}}>
              <Slider dots autoplay>
                <div>
                  <img width='100%' src={logo} alt='client' />
                </div>                
                <div>
                  <img width='100%' src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHW5u6__MSwUDgTHzfEf7YrSPaHNFyTqZXerhL-WaBHOuit8b3-g' alt='client' />              
                </div>          
              </Slider>
            </div>       
            <div id='contact'></div>
          </Grid>
        </main>
        <footer className="page-footer font-small">
          <div style={{backgroundColor: '#4d5ec1', color: 'white'}}>
            <div className="container">
              <div className="row py-4 d-flex align-items-center">
                <div className="col-md-6 col-lg-5 text-center text-md-left mb-4 mb-md-0">
                  <h6 className="mb-0">Get connected with us on social networks!</h6>
                </div>
                <div className="col-md-6 col-lg-7 text-center text-md-right">
                  <button className="fb-ic footer-icons">
                    <i className="fab fa-facebook-f mr-4"> </i>
                  </button>
                  <button className="tw-ic footer-icons">
                    <i className="fab fa-twitter mr-4"> </i>
                  </button>
                  <button className="gplus-ic footer-icons">
                    <i className="fab fa-google-plus-g mr-4"> </i>
                  </button>
                  <button className="li-ic footer-icons">
                    <i className="fab fa-linkedin-in mr-4"> </i>
                  </button>
                  <button className="ins-ic footer-icons">
                    <i className="fab fa-instagram"> </i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div style={{backgroundColor: '#3f51b5', color: 'white'}} className="text-center text-md-left">
            <div className="row p-5">
              <div className="col-md-7 col-lg-7 col-xl-6 mx-auto mb-4">
                <h6 className="text-uppercase font-weight-bold">Contact Us</h6>
                <hr className="accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: 100, background: 'white'}} />
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <form>
                        <div className="form-group">
                          <label htmlFor="name">Name</label>
                          <input type="text" className="form-control" id="name" aria-describedby="emailHelp" placeholder="Enter name" required />
                        </div>
                        <div className="form-group">
                          <label htmlFor="email">Email address</label>
                          <input type="email" className="form-control" id="email" aria-describedby="emailHelp" placeholder="Enter email" required />                  
                        </div>
                        <div className="form-group">
                          <label htmlFor="message">Message</label>
                          <textarea style={{resize: 'none'}} className="form-control" id="message" rows="6" required></textarea>
                        </div>
                        <div className="text-center">
                          <Button type="submit" style={{color: 'white', backgroundColor: '#7280ce'}} fullWidth={true} size="large">Submit</Button>
                        </div>
                      </form>    
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-5 col-lg-4 col-xl-4 mx-auto mb-md-0 mb-4 mt-1">
                <h6 className="text-uppercase font-weight-bold">Our Satisfied Clients</h6>
                <hr className="accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: 180, background: 'white'}} />
                <Slider dots>
                  <div className="container">
                    <blockquote className="quote-box">
                      <p className="quotation-mark">
                        “
                      </p>
                      <p className="quote-text">
                       Console provide great quality work. Its my first priority for app development.
                      </p>
                      <hr />
                      <div className="blog-post-actions">
                        <p className="blog-post-bottom pull-left clientName">
                          <span>Nabeel Qaimkhaani</span><br />
                          <strong>Graphic Designer - KU Education</strong>
                        </p>
                      </div>
                    </blockquote>
                  </div>
                  <div className="container">
                    <blockquote className="quote-box">
                      <p className="quotation-mark">
                        “
                      </p>
                      <p className="quote-text">
                       I would refer to choose console for IT Solutions.
                      </p>
                      <hr />
                      <div className="blog-post-actions">
                        <p className="blog-post-bottom pull-left clientName">
                          <span>Ubaid Khan</span><br />
                          <strong>Wordpress Developer - Buywatch Enterprises</strong>
                        </p>
                        
                      </div>
                    </blockquote>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
          <div style={{backgroundColor: '#3849a2', color: 'white'}} className="text-center text-md-left">
            <div className="row p-5">
              <div className="col-md-8 col-lg-8 col-xl-7 mx-auto mb-4">
                <h6 className="text-uppercase font-weight-bold">Our Mission</h6>
                <hr className="accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: 100, background: 'white'}} />
                <p>Our Mission is to satify our clients by providing them excellent quality service at reasonable price.</p>
              </div>
              <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase font-weight-bold">Contact</h6>
                <hr className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: 70, background: 'white'}} />
                <p>
                  <i className="fas fa-home mr-3"></i> Karachi, Pakistan</p>
                <p>
                  <i className="fas fa-envelope mr-3"></i> abcefg@gmail.com</p>
                <p>
                  <i className="fas fa-phone mr-3"></i> + 92 111 1111111</p>
                  {/* <button onClick={_ => this.sendaMail()}>CLICK ME</button> */}
              </div>
            </div>
          </div>
          <div style={{backgroundColor: '#32408f', color: 'white'}} className="footer-copyright text-center py-3">
            © 2019 Console. All Rights Reserved
          </div>
        </footer>
      </React.Fragment>
    );
  }

  sendaMail = () => { 
      window.emailjs.send(
        'gmail',
        'template_t1azIZXQ',
        {
          "from_name": "Tahir Anwar",
          "from_email": "ifuproduct@gmail.com",
          "message_html": "Hello World Testing!!!"
        })
        .then(res => {
          console.log(res)
        })
        // Handle errors here however you like, or use a React error boundary
        .catch(err => console.error('Failed to send feedback. Error: ', err))

  }

  componentDidMount() {
    window.onscroll = () => { 
      if(window.pageYOffset < 703) {
        this.setState({ active: 0 })
      }
      else if(window.pageYOffset > 702 && window.pageYOffset < 1551) {
        this.setState({ active: 1 })
      }
      else if(window.pageYOffset > 1550 && window.pageYOffset < 2361) {
        this.setState({ active: 2 })
      }
      else if(window.pageYOffset > 2360 && window.pageYOffset < 3183) {
        this.setState({ active: 3 })
      }
      else if(window.pageYOffset > 3182) {
        this.setState({ active: 4 })
      }
      
    }
    
  }

}


export default App;